export const renderDefaultListingSizes = [
  '(max-width: 549px) 100vw',
  '(max-width: 767px) 50vw',
  `(max-width: 1439px) 26vw`,
  `(max-width: 1920px) 18vw`,
  `14vw`,
].join(', ');

export const listingFieldsConfig = {
  LISTING_UNAVAILABILITY: 'listing_unavailability',
  LISTING_PRICING: 'listing_pricing',
};

export const listingPricing = Object.freeze({
  FIXED_PRICE: 'fixed_price',
  ONE_WEEK_AUCTION: 'one_week_auction',
  BLIND_AUCTION: 'blind_auction',
});

export const EditListingCurrencyIds = {
  BUY_NOW_PRICE: 'buyNowPrice',
};

export const FieldConfigKeys = {
  LISTING_MEDIA_TYPES: 'listing_media_types',
  ITEM_SOURCE: 'item_source',
  INVENTORY_PREPPED: 'inventory_prepped',
  LISTING_PRICING: 'listing_pricing',
  GRADING_STATUS: 'grading_status',
};

export const LISTING_MIN_PRICE = 0;
export const BASE_CURRENCY = 'USD';
export const BASE_CURRENCY_SYMBOL = '$';

export const MOBILE_MODAL_BREAKPOINT = 768;

export const BOOKING_TYPES = {
  OFFER: 'offer',
  PURCHASE: 'purchase',
};

export const OFFER_CONSTANTS = {
  INITIAL: 'initial',
  OFFERED: 'offered',
  ACCEPTED: 'accepted',
  DECLINED: 'declined',
  COUNTER: 'counter',
  COUNTER_BY_CUSTOMER: 'counterByCustomer',
  PENDING: 'pending',
  ACCEPT: 'accept',
  ACCEPT_AFTER_COUNTER_OFFER: 'acceptAfterCounterOffer',
  ACCEPT_AFTER_COUNTER_OFFER_BY_PROVIDER: 'acceptAfterCounterOfferByProvider',
  DECLINE_AFTER_COUNTER_OFFER: 'declineAfterCounterOffer',
  DECLINE_AFTER_COUNTER_OFFER_BY_PROVIDER: 'declineAfterCounterOfferByProvider',
};

export const OFFER_STATE_COLORS = {
  OFFERED: '#f77f00',
  ACCEPTED: '#1e4c2f',
  DECLINED: '#59766c',
  EXPIRED: '#ED1B24',
};
export const StatusCode = Object.freeze({
  SUCCESS: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
  TOO_MANY_REQUESTS: 429,
});
export const DeliveryMethod = Object.freeze({
  SHIPPING: 'shipping',
  PICKUP: 'pickup',
});

export const TransactionType = Object.freeze({
  ORDER: 'order',
  SALE: 'sale',
});
// These tabs are being used in checkout page for just payment without shipping
export const paymentTabs = [
  {
    key: 'shippingDetails',
    label: 'Your Information',
  },
  {
    key: 'payment',
    label: 'Payment',
  },
];


export const RENDER_CARRIER_ERROR = {
  PALLET_WEIGHT: 'Weight exceeds the limit of 40000.',
  NUMBER_OF_PALLET: 'Number of pallets exceeds the limit of 48.',
};